import { getPageConfigDataByKey, getPageInitDataByKey } from '../';

export const getSessionTrackingKey = () => ({
    appName: getPageConfigDataByKey('appName', {}),
    pageloadTk: getPageInitDataByKey('pageloadTk', ''),
});
